import React from 'react';
import { classNames } from 'primereact/utils';

export default function SectionFooter({ buttonConfig, clickCallback }) {
  function mapButton(button) {
    const className = classNames('btn', 'btn-sm', { 'btn-primary': button.primary, 'btn-default': !button.primary });
    return (
      <button key={button.id} className={className} onClick={() => handleClick(button)} disabled={button.disabled}>
        <span>{button.name}</span>
      </button>
    );
  }

  function handleClick(button) {
    clickCallback(button);
  }

  // TODO: .on-active-panel support?
  return (
    <div className="form-button-row">
      <div className="pull-right">{buttonConfig.map(button => mapButton(button))}</div>
    </div>
  );
}